require('./bootstrap');
window.Dropzone = require('dropzone');
Dropzone.autoDiscover = false;
require('./script')
require('./images')